export default __webpack_public_path__ + "static/media/mediumDeskFill.05a9c5a1.svg";